import { render, staticRenderFns } from "./InvalidFormError.vue?vue&type=template&id=5d2b050c&"
import script from "./InvalidFormError.vue?vue&type=script&lang=js&"
export * from "./InvalidFormError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports